// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__TcOuB","highlights":"Form_highlights__zHi2U","description":"Form_description__jnwlp","advantages":"Form_advantages__2pKqE"};